module.exports = __webpack_public_path__ + "img/2.801984eb.png";